import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isNil } from 'lodash';
import styles from './styles.scss';

class Tabs extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        selected: PropTypes.number,
        defaultSelected: PropTypes.number,
        children: PropTypes.array.isRequired,
        onSelect: PropTypes.func,
    };

    static defaultProps = {
        defaultSelected: 0,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.selected !== state.prevSelected) {
            const isControlled = !isNil(props.selected);

            return {
                isControlled,
                selected: isControlled ? props.selected : props.defaultSelected,
                prevSelected: props.selected,
            };
        }

        return null;
    }

    state = {
        isControlled: false,
        selected: this.props.defaultSelected,
    };

    handleClick(index, e) {
        e.preventDefault();
        const { isControlled } = this.state;
        const { onSelect } = this.props;

        !isControlled && this.setState({ selected: index });
        onSelect && onSelect(index);
    }

    render() {
        const { selected } = this.state;
        const { className, children } = this.props;
        let index = 0;
        const _children = React.Children.map(children, (el) => {
            if (el.type.role === 'Tab') {
                const newEl = React.cloneElement(el, {
                    ...el.props,
                    isSelected: index === selected,
                    onClick: this.handleClick.bind(this, index),
                });

                index++;
                return newEl;
            }

            return el;
        });

        return <div className={classNames(styles.tabs, className)}>{_children}</div>;
    }
}

Tabs.role = 'Tabs';

export default Tabs;
